/* eslint-disable no-sequences */
// AXIOS
import axios from "axios";

// api url
import { appState, apiToken, apiUrl_forMultipliers, apiUrl_forMultipliers2 } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

const storeId = appState?.auth?.storeId

// get multipliers
export let cancelGetMultipliersApi;
export async function getMultipliers(headers) {
    if (headers) {
        const multipliers = await axios.get(apiUrl_forMultipliers + "settings/multipliers", {
            headers: { ...headers },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetMultipliersApi = c;
            }),
        });
        return multipliers;
    } else {
        console.log("Please add required parameters");
    }
}

// update multiplier
export let cancelEditMultiplierApi;
export async function editmultipliers(headers, multiplierData) {
    if (headers && multiplierData) {
        const multipliers = await axios.put(apiUrl_forMultipliers + "settings/multipliers",
            multiplierData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditMultiplierApi = c;
                }),
            }
        );
        return multipliers;
    } else {
        console.log("Please add required parameters");
    }
}


// update brand multiplier
export let cancelBrandMultiplierApi;
export async function updateBrandMultiplier(headers, brandMultiplierData) {
    if (headers && brandMultiplierData) {
        const brandMultiplier = await axios.put(apiUrl_forMultipliers + "brands/multipliers",
            { data: brandMultiplierData },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelBrandMultiplierApi = c;
                }),
            }
        );
        return brandMultiplier;
    } else {
        console.log("Please add required parameters");
    }
}

// update brand multiplier
export let cancelCategoryMultiplierApi;
export async function updateCategoryMultiplier(headers, categoryMultiplierData) {
    if (headers && categoryMultiplierData) {
        const categoryMultiplier = await axios.put(apiUrl_forMultipliers + "categories/multipliers",
            { data: categoryMultiplierData },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelCategoryMultiplierApi = c;
                }),
            }
        );
        return categoryMultiplier;
    } else {
        console.log("Please add required parameters");
    }
}

// update product multiplier
export let cancelProductMultiplierApi;
export async function updateProductMultiplier(headers, productMultiplierData) {
    if (headers && productMultiplierData) {
        const productMultiplier = await axios.put(apiUrl_forMultipliers + "products/multipliers",
            { data: productMultiplierData },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelProductMultiplierApi = c;
                }),
            }
        );
        return productMultiplier;
    } else {
        console.log("Please add required parameters");
    }
}

// update shipping multiplier
export let cancelAddShippingMultiplierApi;
export async function addShippingMultiplierApi(headers, {range_from, range_to, price}) {
    if (headers && range_from && range_to && price) {
        const productMultiplier = await axios.post(apiUrl_forMultipliers2 + "shipping/multiplier",
            { range_from, range_to, price },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddShippingMultiplierApi = c;
                }),
            }
        );
        return productMultiplier;
    } else {
        console.log("Please add required parameters");
    }
}

// get shipping multiplier
export let cancelGetShippingMultiplierApi;
export async function getShippingMultiplierApi(headers) {
    if (headers) {
        const productMultiplier = await axios.get(apiUrl_forMultipliers2 + "shipping/multiplier",
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetShippingMultiplierApi = c;
                }),
            }
        );
        return productMultiplier;
    } else {
        console.log("Please add required parameters");
    }
}